/* eslint-disable react-hooks/exhaustive-deps */
import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  buscarUnidad,
  listarDestinosResiduosSolidosUrbanos,
  listarMateriales,
  listarTecnologiasTratamiento,
} from "../api/General";
import { useCatalog } from "../context/Catalog";
import { useTramite } from "../context/Tramite";
import "./css/components.css";
import { crearResiduoSolidoUrbano } from "../utils/data";
import { isInvalid } from "../utils/forms";
import { isEditable } from "../utils/tramite";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import QuestionField from "./controls/QuestionField";
import CheckboxField from "./controls/CheckboxField";
import TextField from "./controls/TextField";
import TextareaField from "./controls/TextareaField";
import ArrayField from "./controls/ArrayField";
import { ResiduoSolidoUrbanoForm } from "./ResiduoSolidoUrbanoForm";
import { ResiduoSolidoUrbanoList } from "./ResiduoSolidoUrbanoList";

function ordenarTecnologias(tecnologias) {
  if (!tecnologias) return tecnologias;
  return [...tecnologias].sort((a, b) => {
    if (a.codigo === "U9") return 1;
    if (b.codigo === "U9") return -1;
    return a.nombre > b.nombre;
  });
}

export default function ResiduosSolidosUrbanosForm({ ...props }) {
  const { tramite } = useTramite();
  const tramiteForm = useFormikContext();
  const { t } = useTranslation();
  const tecnologiasCatalog = useCatalog(
    ["tecnologiasTratamiento", "URBANO"],
    () => listarTecnologiasTratamiento({ tipo: "URBANO" }),
  );
  const destinosCatalog = useCatalog(
    ["destinosResiduosSolidosUrbanos", "URBANO"],
    () => listarDestinosResiduosSolidosUrbanos({ tipo: "URBANO" }),
  );
  const materialesCatalog = useCatalog(["materiales"], () =>
    listarMateriales({}),
  );
  const unidadCantidadCatalog = useCatalog(["unidad", "KG"], () =>
    buscarUnidad("KG"),
  );
  const loading =
    tecnologiasCatalog.loading ||
    destinosCatalog.loading ||
    materialesCatalog.loading ||
    unidadCantidadCatalog.loading;
  const handleConTratamientoRSUInternoChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleTratamientosRSUChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleEsGeneradorRSUEspecialesChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleRegistroRSUEspecialesChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleDisponeRSUCEAMSEChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleRegistroAltaCEAMSEChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleDisposicionRSUChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleDisposicionCertificadosRSUChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleResiduosSolidosUrbanosChange = (event) => {
    tramiteForm.handleChange(event);
  };
  useEffect(() => {
    if (tramiteForm.values.esGeneradorRSUEspeciales) {
      tramiteForm.setFieldValue(
        "registroRSUEspeciales",
        tramite.registroRSUEspeciales,
        true,
      );
    } else {
      tramiteForm.setFieldValue("registroRSUEspeciales", null, true);
    }
  }, [tramiteForm.values.esGeneradorRSUEspeciales]);
  useEffect(() => {
    if (tramiteForm.values.disponeRSUCEAMSE) {
      tramiteForm.setFieldValue(
        "registroAltaCEAMSE",
        tramite.registroAltaCEAMSE,
        true,
      );
    } else {
      tramiteForm.setFieldValue("registroAltaCEAMSE", null, true);
    }
  }, [tramiteForm.values.disponeRSUCEAMSE]);
  useEffect(() => {
    if (
      !tramiteForm.values.conTratamientoRSUInterno &&
      tramiteForm.values.tratamientosRSU?.length > 0
    ) {
      tramiteForm.setFieldValue("tratamientosRSU", []);
    }
  }, [tramiteForm.values.conTratamientoRSUInterno]);
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col lg={12}>
            <QuestionField
              id="conTratamientoRSUInterno"
              name="conTratamientoRSUInterno"
              label={t("tramite.conTratamientoRSUInterno")}
              value={tramiteForm.values?.conTratamientoRSUInterno}
              onChange={handleConTratamientoRSUInternoChange}
              isInvalid={isInvalid("conTratamientoRSUInterno", tramiteForm)}
              error={t(tramiteForm.errors.conTratamientoRSUInterno)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <CheckboxField
              id="tratamientosRSU"
              name="tratamientosRSU"
              label={t("tramite.tratamientosRSU")}
              value={tramiteForm.values?.tratamientosRSU}
              onChange={handleTratamientosRSUChange}
              lg={6}
              options={ordenarTecnologias(tecnologiasCatalog.data)}
              labelAttr="nombre"
              valueAttr="codigo"
              isInvalid={isInvalid("tratamientosRSU", tramiteForm)}
              error={t(tramiteForm.errors.tratamientosRSU)}
              disabled={
                !isEditable(tramite) ||
                !tramiteForm.values.conTratamientoRSUInterno
              }
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <QuestionField
              id="esGeneradorRSUEspeciales"
              name="esGeneradorRSUEspeciales"
              label={t("tramite.esGeneradorRSUEspeciales")}
              value={tramiteForm.values?.esGeneradorRSUEspeciales}
              onChange={handleEsGeneradorRSUEspecialesChange}
              isInvalid={isInvalid("esGeneradorRSUEspeciales", tramiteForm)}
              error={t(tramiteForm.errors.esGeneradorRSUEspeciales)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={4}>
            <TextField
              id="registroRSUEspeciales"
              name="registroRSUEspeciales"
              label={t("tramite.registroRSUEspeciales")}
              value={tramiteForm.values?.registroRSUEspeciales}
              onChange={handleRegistroRSUEspecialesChange}
              isInvalid={isInvalid("registroRSUEspeciales", tramiteForm)}
              error={t(tramiteForm.errors.registroRSUEspeciales)}
              maxLength={20}
              disabled={
                !isEditable(tramite) ||
                !tramiteForm.values.esGeneradorRSUEspeciales
              }
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <QuestionField
              id="disponeRSUCEAMSE"
              name="disponeRSUCEAMSE"
              label={t("tramite.disponeRSUCEAMSE")}
              value={tramiteForm.values?.disponeRSUCEAMSE}
              onChange={handleDisponeRSUCEAMSEChange}
              isInvalid={isInvalid("disponeRSUCEAMSE", tramiteForm)}
              error={t(tramiteForm.errors.disponeRSUCEAMSE)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={4}>
            <TextField
              id="registroAltaCEAMSE"
              name="registroAltaCEAMSE"
              label={t("tramite.registroAltaCEAMSE")}
              value={tramiteForm.values?.registroAltaCEAMSE}
              onChange={handleRegistroAltaCEAMSEChange}
              isInvalid={isInvalid("registroAltaCEAMSE", tramiteForm)}
              maxLength={20}
              error={t(tramiteForm.errors.registroAltaCEAMSE)}
              disabled={
                !isEditable(tramite) || !tramiteForm.values.disponeRSUCEAMSE
              }
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <TextareaField
              id="disposicionRSU"
              name="disposicionRSU"
              label={t("tramite.disposicionRSU")}
              value={tramiteForm.values?.disposicionRSU}
              onChange={handleDisposicionRSUChange}
              rows={12}
              maxLength={1024}
              isInvalid={isInvalid("disposicionRSU", tramiteForm)}
              error={t(tramiteForm.errors.disposicionRSU)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={4}>
            <TextField
              id="disposicionCertificadosRSU"
              name="disposicionCertificadosRSU"
              label={t("tramite.disposicionCertificadosRSU")}
              value={tramiteForm.values?.disposicionCertificadosRSU}
              onChange={handleDisposicionCertificadosRSUChange}
              labelStyle={{ whiteSpace: "nowrap" }}
              maxLength={20}
              isInvalid={isInvalid("disposicionCertificadosRSU", tramiteForm)}
              error={t(tramiteForm.errors.disposicionCertificadosRSU)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrayField
              id="residuosSolidosUrbanos"
              name="residuosSolidosUrbanos"
              label={t("tramite.residuosSolidosUrbanos")}
              value={tramiteForm.values?.residuosSolidosUrbanos}
              onChange={handleResiduosSolidosUrbanosChange}
              createItem={crearResiduoSolidoUrbano}
              isInvalid={isInvalid("residuosSolidosUrbanos", tramiteForm)}
              error={
                (tramiteForm.errors.residuosSolidosUrbanos instanceof Array &&
                  t("errors.tramite.residuosSolidosUrbanos.many")) ||
                t(tramiteForm.errors.residuosSolidosUrbanos)
              }
              disabled={!isEditable(tramite)}
            >
              {({
                value: residuosSolidosUrbanos,
                append,
                remove,
                replace,
                select,
                selectedIndex,
                selectedItem,
                disabled,
              }) => (
                <Grid>
                  {!disabled && (
                    <Row>
                      <Col>
                        <ResiduoSolidoUrbanoForm
                          value={selectedItem}
                          page={selectedIndex}
                          pages={residuosSolidosUrbanos.length}
                          select={select}
                          append={append}
                          replace={replace}
                          remove={remove}
                          destinos={destinosCatalog.data}
                          materiales={materialesCatalog.data}
                          unidadCantidad={unidadCantidadCatalog.data}
                          operacionesUnitarias={
                            tramiteForm.values.operacionesUnitarias
                          }
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <ResiduoSolidoUrbanoList
                        value={residuosSolidosUrbanos}
                        select={select}
                        remove={remove}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ArrayField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
